import { render } from "./HorizontalStepsDiagram.vue?vue&type=template&id=52afe657"
import script from "./HorizontalStepsDiagram.vue?vue&type=script&lang=js"
export * from "./HorizontalStepsDiagram.vue?vue&type=script&lang=js"

import "./HorizontalStepsDiagram.vue?vue&type=style&index=0&id=52afe657&lang=css"

import exportComponent from "D:\\Projects\\peles\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__